export enum FTUE_FLAG_TYPES {
  GIFT_CARD_PURCHASE_FORM = 'gift_card_purchase_form',
  COMPANY_ADMIN_DASHBOARD = 'company_admin_dashboard'
}

export interface FtueFlags {
  gift_card_purchase_form: boolean;
  company_admin_dashboard: boolean;
}
